import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { Col, Form, Row } from "react-bootstrap";
import DoubleListbox from "../../../../components/UI/DoubleListbox/DoubleListbox";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import useAssociarAtividades from "./useAssociarAtividades";
import useDesassociarAtividade from "./useDesassociarAtividade";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";

const useAssociacaoAtividades = ({ roteiro }) => {
  const [atividadesDisponiveis, setAtividadesDisponiveis] = useState([]);
  const [atividadesAssociadas, setAtividadesAssociadas] = useState([]);
  const { request, data, errors, isLoading } = useApiClient();

  const requestAtividadesHandler = useCallback(() => {
    if (roteiro.sequencialRoteiro) {
      const params = { sequencialRoteiro: roteiro.sequencialRoteiro };
      request(apiRoutes.fiscalizacao.parametrizacao.associacaoAtividadesRoteiro, params);
    }
  }, [request, roteiro.sequencialRoteiro]);

  useEffect(() => {
    requestAtividadesHandler();
  }, [requestAtividadesHandler]);

  useEffect(() => {
    if (data?.result) {
      const disponiveis = _.filter(data.result, (item) => !item.associado).map((item) => ({
        chave: item.sequencialAtividade,
        descricao: `(${item.siglaAtividade}) ${item.nomeAtividade}`,
        nomeAtividade: item.nomeAtividade,
      }));

      setAtividadesDisponiveis(disponiveis.sort((a, b) => a.nomeAtividade.localeCompare(b.nomeAtividade)));

      const associadas = _.filter(data.result, (item) => item.associado > 0).map((item) => {
        let ordenador = 1;
        if (item.finalidade.toLowerCase() === "Início".toLowerCase()) {
          ordenador = 0;
        } else if (item.finalidade.toLowerCase() === "Encerramento".toLowerCase()) {
          ordenador = 2;
        }

        return {
          chave: item.sequencialAtividade,
          descricao: `(${item.siglaAtividade}) ${item.nomeAtividade} - ${item.finalidade}`,
          nomeAtividade: item.nomeAtividade,
          ordenador: `${ordenador}${item.nomeAtividade}`,
        };
      });

      setAtividadesAssociadas(associadas.sort((a, b) => a.ordenador.localeCompare(b.ordenador)));
    }
  }, [data]);

  const { associarAtividadesModal, onAddHandler } = useAssociarAtividades({
    roteiro,
    onChange: requestAtividadesHandler,
  });

  const { isLoading: isLoadingDesassociacao, onRemoveHandler } = useDesassociarAtividade({
    roteiro,
    onChange: requestAtividadesHandler,
  });

  const associacaoListas = (
    <>
      {associarAtividadesModal}
      <Row>
        <Form.Group as={Col} sm={12} md={12}>
          <h6 className="m-0 font-weight-bold text-primary flex-grow-1">Associação de Atividades</h6>
        </Form.Group>
      </Row>
      <FormAlert isLoading={isLoading} errors={errors} />
      <DoubleListbox
        tituloEsquerda="Atividades não associadas ao roteiro"
        tituloDireita="Atividades associadas ao roteiro"
        textoBotaoAdicionar="Associar"
        textoBotaoRemover="Desassociar"
        listaEsquerda={atividadesDisponiveis}
        listaDireita={atividadesAssociadas}
        disabled={isLoading || isLoadingDesassociacao}
        onAdd={onAddHandler}
        onRemove={onRemoveHandler}
        itensVisiveis={10}
      />
    </>
  );

  return { associacaoListas };
};

export default useAssociacaoAtividades;
